import React from "react";
import { observer } from "mobx-react";
import "../styles/Immersive3dTourPanelUiMeet3dHomeContent.less";
import UiMeet3dHomeContent from "~/modules/UiMeet3d/components/UiMeet3dHomeContent";

const Immersive3dTourPanelUiMeet3dHomeContent = observer(props => <UiMeet3dHomeContent {...props} />);

export default Immersive3dTourPanelUiMeet3dHomeContent;
